<template>
  <bpb-form-communicator v-model="internalValue" :name="name">
    <div :id="id" class="input-multiselect" v-bind="$fieldUpdateBinding">
      <slot />
      <bpb-form-error-portal :name="name" />
    </div>
  </bpb-form-communicator>
</template>

<script>
import {
  InputIdProvider,
  FieldUpdateProvider,
} from '@components/molecules/form/form.mixin.js';

export default {
  mixins: [
    InputIdProvider,
    FieldUpdateProvider({ baseClass: 'input-multiselect' }),
  ],

  provide() {
    const context = {};
    Object.defineProperty(context, 'name', {
      enumerable: true,
      get: () => this.name,
    });
    Object.defineProperty(context, 'id', {
      enumerable: true,
      get: () => this.id,
    });
    Object.defineProperty(context, 'internalValue', {
      enumerable: true,
      get: () => this.internalValue,
    });
    return {
      context,
      onOptionChange: this.onOptionChange,
      syncOption: this.syncOption,
    };
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    minCheckedCount: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      internalValue: this.value,
      uuid: this.$uuid.v1(),
      options: {},
    };
  },
  computed: {
    allButtonValues() {
      return Object.values(this.options)
        .map(option => option.isAllButton && option.value)
        .filter(Boolean);
    },
  },
  methods: {
    syncOption(uuid, data) {
      this.$set(this.options, uuid, data);
    },
    onOptionChange(value, checked) {
      checked ? this.add(value) : this.remove(value);
    },
    add(value) {
      let componentValue = [...this.internalValue];

      if (componentValue.includes(value)) return false;
      componentValue.push(value);

      const isAllButton = this.allButtonValues.includes(value);

      // either an "all" buttons are checked OR normal buttons
      componentValue = componentValue.filter(value => {
        return isAllButton === this.allButtonValues.includes(value);
      });

      this.set(componentValue);
    },
    remove(value) {
      if (this.minCheckedCount >= this.internalValue.length) return false;

      // if checks are passed, do the rest by data binding
      let componentValue = [...this.internalValue];

      if (componentValue.includes(value)) {
        componentValue.splice(componentValue.indexOf(value), 1);
      }

      this.set(componentValue);
    },
    set(value) {
      this.internalValue = value;
      this.$emit('change', value);
    },
  },
};
</script>
